export default "__VITE_ASSET__DHE9CWb___"